import { useState, useEffect } from 'react';
import ChartBubble from '@/pages/intelligence/components/ChartBubble';
import ConsoleGameDefault from '@/pages/intelligence/assets/imgs/common/consolegame-default.png';
import { ECHARTSCOLOR } from '@/pages/intelligence/utils/echartsConst';
import { getPieWidth, getPieAndPieTitlePosition } from '@/pages/intelligence/utils/echartsUtils';
import { LEGEND_BOTTOM } from '@/pages/intelligence/pages/TopCharts/_config/echarts';
import usePieChartsHoverEffect from '@intelligence/components/Chart/hooks/usePieChartsHoverEffect';
import { getPieChartLabelBaseRich, formatPieChartLabel } from '@intelligence/utils/echartsUtils';
import { PIE_CHART_TOOLTIP_BASE_OPTION } from '@intelligence/utils/echartsConst';

const handleAUEChartsParams = (params: any): any => {
  return {
    ...params,
    percent: params?.value,
    value: params?.data?.barValue,
  };
};

export default function useMultiDataSourcePieCharts(props: any) {
  const {
    chartType,
    chartsInstance,
    sendEchartsData,
    loading,
    dataSourceEachers,
    lenten,
    titleNow,
    startDate,
    endDate,
    gameHighId = '',
    isStudio = false,
  } = props;

  // 饼图的数据
  const [PieEcharts, setPeiEcharts] = useState<any>(null);
  const [pieOption, setPieOption] = useState(null);

  const formatPieChartLabelAU = (params: any) => {
    const paramsNew = handleAUEChartsParams(params);
    const isHigh = gameHighId === '' && !isStudio ? false : params?.data?.gameId == gameHighId;
    return formatPieChartLabel(paramsNew, isHigh);
  };

  usePieChartsHoverEffect({
    loading,
    chartType,
    chartsInstance,
    setOption: setPieOption,
  });

  useEffect(() => {
    if (
      sendEchartsData !== undefined &&
      sendEchartsData !== null &&
      sendEchartsData?.length !== 0 &&
      // 修改判断方式，避免 all of time 数据量过大，导致 JSON.stringify 报错
      // JSON.stringify(sendEchartsData) !== '{}'
      Object.keys(sendEchartsData).length !== 0
    ) {
      // 饼图和柱状图数据结构改变
      PieBarEchartsList();
    }
  }, [sendEchartsData]);

  // 饼图和柱状图数据结构改变
  const PieBarEchartsList = async () => {
    const TempPieEcharts: any[] = [];
    const pieOther: any[] = [];
    const allNum: any[] = [];
    const sourceList: any[] = [];
    lenten?.map((item: any, index: any) => {
      if (item.metric_list) {
        item.metric_list?.map((citem: any, cindex: any) => {
          if (index === 0) {
            sourceList?.push(citem.source);
            pieOther?.push(0);
            allNum?.push(0);
          }
        });
      } else {
        item?.metric_value_list?.map((citem: any, cindex: any) => {
          if (index === 0) {
            sourceList?.push(citem.source);
            pieOther?.push(0);
            allNum?.push(0);
          }
        });
      }
    });
    lenten?.map((item: any, index: any) => {
      if (item.metric_list) {
        item.metric_list?.map((citem: any, cindex: any) => {
          allNum[cindex] += citem.value * 1;
          if (index >= 5) {
            pieOther[cindex] += citem.value * 1;
          }
        });
      } else {
        item.metric_value_list?.map((citem: any, cindex: any) => {
          allNum[cindex] += citem.value * 1;
          if (index >= 5) {
            pieOther[cindex] += citem.value * 1;
          }
        });
      }
    });
    sourceList?.map(() => {
      TempPieEcharts?.push([]);
    });
    lenten?.map((item: any, index: any) => {
      const metricList = item.metric_list || item.metric_value_list;
      metricList?.map((citem: any, cindex: any) => {
        const url = item.imageUrl || ConsoleGameDefault;
        if (index === 5) {
          TempPieEcharts[cindex]?.push({
            url,
            name: 'Other',
            value: ((pieOther[cindex] / allNum[cindex]) * 100).toFixed(2),
            barvalue: citem.value,
            gameId: item?.gameId,
            source: citem.source,
            color: ECHARTSCOLOR[index],
            index: ECHARTSCOLOR[index].replace('#', ''),
          });
        }
        if (index < 5) {
          TempPieEcharts[cindex]?.push({
            url,
            name: item.rank_metric,
            value: ((citem.value / allNum[cindex]) * 100).toFixed(2),
            barvalue: citem.value,
            gameId: item?.gameId,
            source: citem.source,
            color: ECHARTSCOLOR[index],
            index: ECHARTSCOLOR[index].replace('#', ''),
          });
        }
      });
    });
    setPeiEcharts(TempPieEcharts);
  };

  useEffect(() => {
    if (PieEcharts && !loading) {
      handleEchartPie(dataSourceEachers); // 饼图
    }
  }, [PieEcharts, loading, PieEcharts, chartType, titleNow, startDate, endDate]);

  // 设置空数据样式
  const placeHolderStyle = {
    normal: {
      color: '#dcdcdc', // 灰色
      label: {
        show: false,
      },
      labelLine: {
        show: false,
      },
    },
  };

  // 检查数据是否为空
  function isEmptyData(data) {
    return data?.every((item) => {
      return item.value === 'NaN' || item.value === 0;
    });
  }

  // 饼图
  const handleEchartPie = (arr: any) => {
    let tapeoption: any = {};
    const datas: any = [];
    const title: any = [];
    arr?.map((item: any, index: any) => {
      const { titleLeft } = getPieAndPieTitlePosition(dataSourceEachers, index);
      // 解决多个tab数据问题
      // let findIndex = PieEcharts.findIndex((bar) => bar[0]?.source === item.replace(/\s+/g, '').toLocaleLowerCase())
      datas?.push(PieEcharts[index]);
      title?.push({
        text: item,
        left: titleLeft,
        // top: '46%',
        top: '47%',
        x: arr?.length > 1 ? 'center' : '',
        y: arr?.length > 1 ? 'center' : '',
        textAlign: arr?.length > 1 ? 'center' : '',
        textStyle: {
          fontWeight: 600,
          fontSize: 12,
          color: '#262832',
          // width: 85,
          width: 100,
          overflow: 'truncate',
        },
      });
    });
    tapeoption = {
      calculable: true,
      color: ECHARTSCOLOR,
      legend: {
        // bottom: 0,
        itemGap: 18,
        width: '100%',
        type: 'scroll',
        orient: 'horizontal', // 横向
        pageIconColor: '#ff781f', // 翻页箭头颜色
        selectedMode: true,
        pageIconSize: 13,
        pageTextStyle: {
          color: '#999', // 翻页数字颜色
        }, // 翻页数字设置
        show: true,
        icon: 'circle',
        itemWidth: 20,
        itemHeight: 10,
        // padding:[20,0,0,0],
        left: 'center',
        // bottom: 10,
        bottom: LEGEND_BOTTOM,
        textStyle: {
          color: '#888888',
          fontSize: 12,
          rich: {
            a: {
              color: '#888888',
              fontSize: 12,
            },
            boldB: {
              color: '#262832',
              fontSize: 12,
              fontWeight: 'bold',
            },
          },
        },
        itemStyle: {
          opacity: 1,
        },
        data: datas?.[0]?.map((data: any) => {
          const { name, color } = data || {};
          return {
            name,
            icon: 'circle',
            itemStyle: {
              color,
            },
          };
        }),
        formatter: (name: any) => {
          const showObj = sendEchartsData?.metricChartlist?.find((v: any) => v?.name == name) || {};
          const showId = showObj?.gameId || '';
          // const showText = showObj?.name || '';
          // // 高亮legend标题
          return `{${gameHighId === showId && isStudio ? 'boldB' : 'a'}|${name}}`;
        },
      },
      title,
      tooltip: {
        ...PIE_CHART_TOOLTIP_BASE_OPTION,
        formatter: (params: any) => {
          const paramsNew = handleAUEChartsParams(params);
          return ChartBubble({
            chartType,
            titleNow,
            startDate,
            endDate,
            data: paramsNew,
          });
        },
      },
      series: datas?.map((data: any, idx: any) => {
        const { left } = getPieAndPieTitlePosition(dataSourceEachers, idx);
        return {
          type: 'pie',
          // radius: '25%',
          // radius: ['45', '82'],
          radius: [55, 95],
          center: ['50%', '50%'],
          label: {
            padding: [0, -6],
            position: 'outside',
            alignTo: 'labelLine',
            bleedMargin: 5,
            fontSize: 12,
            color: '#262832',
            // formatter: (value: any) => {
            //   return value.name + ': {time|' + value.value + ' %}\n';
            //   return (value.name?.length > 12 ? value.name.slice(0, 11) + '...' : value.name) + ': {time|' + value.value + ' %}\n';
            // },
            formatter: formatPieChartLabelAU,
            rich: {
              ...getPieChartLabelBaseRich(),
              contextbold: {
                padding: [4, 16],
                align: 'left',
                opacity: 1,
                fontWeight: 'bold',
              },
              // time: {
              //   fontWeight: 600,
              //   fontSize: 12,
              //   color: '#000000',
              // },
            },
          },
          labelLine: {
            // 折线弯曲程度配置
            length: 20,
            showAbove: false,
            // minTurnAngle: 80,
            maxSurfaceAngle: 80,
            lineStyle: {
              width: 2,
            },
          },
          // left: idx === 0 ? 0 : idx === 1 ? '33.3333%' : '66.6667%',
          // right: idx === 0 ? '66.6667%' : idx === 1 ? '33.3333%' : 0,
          left,
          width: getPieWidth(dataSourceEachers),
          // emphasis: {
          //   itemStyle: {
          //     shadowBlur: 10,
          //     shadowOffsetX: 0,
          //     shadowColor: 'rgba(0, 0, 0, 0.5)'
          //   },
          // },
          data: data?.map((litem: any) => {
            const barValue = Number.parseFloat(litem?.barvalue);
            return {
              name: litem.name,
              value: litem.value === 'NaN' ? 0 : litem.value,
              barValue: Number.isNaN(barValue) ? 0 : barValue,
              gameId: litem?.gameId,
              itemStyle: {
                color: litem.color,
                ...(isEmptyData(data) ? placeHolderStyle : {}), // 置灰
              },
            };
          }),
          // 空数据展示样式
          // itemStyle: isEmptyData(data) ? placeHolderStyle : null//不散发线条
          itemStyle: {
            ...(isEmptyData(data) ? placeHolderStyle : {}),
            borderRadius: 5,
            borderColor: '#fff',
            borderWidth: 1,
          },
        };
      }),
    };
    setPieOption(tapeoption);
  };

  return {
    pieOption,
  };
}
